var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"productionChart"},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.options,"updateArgs":_vm.updateArgs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }